/**
 * Persistência do cartCode em localStorage + cookie para suportar subdomínios.
 * O cookie com domain pai permite compartilhar o cartCode entre loja e checkout.
 */

const CART_KEY = 'checkout_cart_code';
const COOKIE_MAX_AGE_DAYS = 7;

function getParentDomain(): string | null {
  if (typeof window === 'undefined') return null;
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname.startsWith('127.')) return null;
  const parts = hostname.split('.');
  if (parts.length <= 2) return hostname;
  const tld2 = parts.slice(-2).join('.');
  if (['com.br', 'co.uk', 'com.au', 'net.br', 'org.br'].includes(tld2)) {
    return '.' + parts.slice(-3).join('.');
  }
  return '.' + parts.slice(-2).join('.');
}

function setCookie(name: string, value: string): void {
  try {
    const domain = getParentDomain();
    const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
    let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    if (domain) cookie += `; domain=${domain}`;
    document.cookie = cookie;
  } catch (e) {
    console.error('cartStorage: erro ao setar cookie', e);
  }
}

function getCookie(name: string): string | null {
  try {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  } catch {
    return null;
  }
}

function removeCookie(name: string): void {
  try {
    const domain = getParentDomain();
    let cookie = `${name}=; path=/; max-age=0`;
    if (domain) cookie += `; domain=${domain}`;
    document.cookie = cookie;
  } catch (e) {
    console.error('cartStorage: erro ao remover cookie', e);
  }
}

/** Salva cartCode em localStorage e cookie */
export function setCartCode(cartCode: string): void {
  try {
    localStorage.setItem(CART_KEY, cartCode);
    setCookie(CART_KEY, cartCode);
  } catch (e) {
    console.error('cartStorage: erro ao salvar cartCode', e);
  }
}

/** Lê cartCode: localStorage primeiro, depois cookie */
export function getCartCode(): string | null {
  try {
    const fromLocal = localStorage.getItem(CART_KEY);
    if (fromLocal) return fromLocal;
    return getCookie(CART_KEY);
  } catch {
    return null;
  }
}

/** Remove cartCode de localStorage e cookie */
export function removeCartCode(): void {
  try {
    localStorage.removeItem(CART_KEY);
    removeCookie(CART_KEY);
  } catch (e) {
    console.error('cartStorage: erro ao remover cartCode', e);
  }
}
